export class UserBlockedError extends Error {
  NotAuthenticatedError(message) {
    this.super(message)
  }
}
